import React from 'react';

const HeartBubble: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 182" fill="none" {...props}>
    <path
      fill="#DC2626"
      fillRule="evenodd"
      d="M82 164c45.287 0 82-36.713 82-82S127.287 0 82 0 0 36.713 0 82s36.713 82 82 82zm-.694-44C16.942 81.097 39.038 43.575 62.9 44.003a21.92 21.92 0 012.311.168c9.613 1.172 14.153 6.538 16.29 11.15 2.138-4.612 6.675-9.978 16.29-11.15C122.457 41.16 148.132 79.843 81.719 120a.278.278 0 00-.206-.095.278.278 0 00-.206.095z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#DC2626"
      d="M88.196 179c-2.31 4-8.083 4-10.392 0l-10.392-18c-2.31-4 .577-9 5.196-9h20.784c4.62 0 7.506 5 5.197 9l-10.393 18z"
    ></path>
  </svg>
);

export default HeartBubble;
